import { createSlice } from "@reduxjs/toolkit";
import { ALL_WORKGROUP_DEFAULT_FILTERS, WORKGROUP_MANAGER } from "../../util/constants";

const initialState = {
  searchString: "",
  adminTimeOffRequestFoundByReferenceNumberSearch: null,
  adminTimeOffRequestFoundByReferenceNumberSearchIsLoading: false,
  adminTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen: false,
  searchStringErrors: "",
  availableWorkgroups: ALL_WORKGROUP_DEFAULT_FILTERS.filter((workgroup) => workgroup !== WORKGROUP_MANAGER),
  selectedWorkgroup: "",
  selectedDate: null,
  availableWopTypes: [],
  selectedWopType: "",
};

export const adminTimeOffRequestWOPSlice = createSlice({
  name: "adminTimeOffRequestWOP",
  initialState,
  reducers: {
    updateSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    updateAdminTimeOffRequestFoundByReferenceNumberSearch: (state, action) => {
      state.adminTimeOffRequestFoundByReferenceNumberSearch = action.payload;
    },
    updateAdminTimeOffRequestFoundByReferenceNumberSearchIsLoading: (state, action) => {
      state.adminTimeOffRequestFoundByReferenceNumberSearchIsLoading = action.payload;
    },
    updateAdminTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen: (state, action) => {
      state.adminTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen = action.payload;
    },
    updateSearchStringErrors: (state, action) => {
      state.searchStringErrors = action.payload;
    },
    updateSelectedWorkgroup: (state, action) => {
      state.selectedWorkgroup = action.payload;
    },
    updateSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    updateAvailableWopTypes: (state, action) => {
      state.availableWopTypes = action.payload;
    },
    updateSelectedWopType: (state, action) => {
      state.selectedWopType = action.payload;
    },
    clearAllAdminTimeOffRequestWOPFilters: () => initialState,
  },
});

export const {
  updateSearchString,
  updateAdminTimeOffRequestFoundByReferenceNumberSearch,
  updateAdminTimeOffRequestFoundByReferenceNumberSearchIsLoading,
  updateAdminTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen,
  updateSearchStringErrors,
  clearAllAdminTimeOffRequestWOPFilters,
  updateSelectedWorkgroup,
  updateSelectedDate,
  updateSelectedWopType,
  updateAvailableWopTypes,
} = adminTimeOffRequestWOPSlice.actions;

export const selectAdminTimeOffRequestWOPData = (state) => state.adminTimeOffRequestWOP;

export default adminTimeOffRequestWOPSlice.reducer;
